import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Flex } from '../../grid';
import { GiftOption } from '../gift-option';

const MAX_OPTIONS = 3;

const Wrapper = styled.div`
  background: ${props => props.theme.colors.white};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
`;

const Heading = styled.p`
  font-family: Barlow, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  margin: 0 0 16px 0;
`;

const List = styled(Flex)``;

const GiftPicker = ({ eligibleGiftPlus, giftDetailsByPlu, selectedGiftPlu, onSelect }) => {
  if (!eligibleGiftPlus || eligibleGiftPlus.length === 0) {
    return null;
  }

  // Always render the picker — never auto-select or render an inline button,
  // even when there's only one option (per V7 always-render-picker rule).
  const visible = eligibleGiftPlus.slice(0, MAX_OPTIONS);

  return (
    <Wrapper data-testid="gift-picker">
      <Heading>{`Please choose 1 of ${visible.length} gifts:`}</Heading>
      <List flexDirection="column">
        {visible.map(plu => {
          const details = giftDetailsByPlu[plu] || {};
          return (
            <GiftOption
              key={plu}
              variant="product"
              name={details.name || plu}
              image={details.image || null}
              description={details.description || null}
              isSelected={selectedGiftPlu === plu}
              onSelect={() => onSelect(plu)}
            />
          );
        })}
      </List>
    </Wrapper>
  );
};

GiftPicker.propTypes = {
  eligibleGiftPlus: PropTypes.arrayOf(PropTypes.string).isRequired,
  giftDetailsByPlu: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
      description: PropTypes.string,
    })
  ),
  selectedGiftPlu: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

GiftPicker.defaultProps = {
  giftDetailsByPlu: {},
  selectedGiftPlu: null,
};

export { GiftPicker };
